module.exports = __webpack_public_path__ + "img/leader.cce7ea2e.png";